import React from "react";
import chroma from "chroma-js";
import { ReportingPackageStatusItem } from "AppSrc/user/projectItem/reportingPackageStatusItem";
import { rpName, getStatus } from "storybook-dashboard/dashboard/project/reportStatus";

const getRefName = ({ refs, refId }) => {
  return refs?.getIn([refId, "name"]) || "Reporting Package";
};

export default function RelatedCommits({ project, refs, depth }) {
  let commits = project.get("related_commits");
  if (!commits) return null;

  let projectId = project.get("uid");

  return commits.map((commit, i) => {
    let commitId = commit.get("uid");
    let refId = commit.get("ref_id");

    if (commit.get("is_staging") || !refId) return null;

    // Get the ref name from the refs map
    let refName = commit.get("ref_name") || getRefName({ refs, refId });

    // Get the string of this reporting period
    let dates = rpName(commit);

    // Get the status
    let status = getStatus(commit.get("status_name"));

    let color = chroma("#ffff99").brighten(1).hex();

    return (
      <ReportingPackageStatusItem
        index={i}
        key={i}
        projectId={projectId}
        refId={refId}
        refName={refName}
        commitId={commitId}
        status={status}
        color={color}
        dates={dates}
        depth={depth}
      />
    );
  });
}
